import { useCallback } from 'react';

import { useVideoStreamController_disableBioscopeStream } from '@/services/hooks';

import type { DisableStreamRequest, UseDisableStreamResult } from './types';

export function useDisableStream(): UseDisableStreamResult {
    const mutation = useVideoStreamController_disableBioscopeStream();

    const mutateAsync = useCallback(
        async (variables: DisableStreamRequest) => {
            await mutation.mutateAsync(variables);
            return undefined;
        },
        [mutation.mutateAsync]
    );

    return {
        ...mutation,
        isLoading: mutation.isPending,
        mutateAsync,
        data: undefined,
    };
}
